import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../enums';
import type { CalendarEvent } from '@centric-os/types';
import { Info } from 'luxon';

export default () => {
  const { translate } = useTranslation();
  const LOCALE_PREFIX = SitesLocalePrefix.SITE_SCHEDULE_SIDE_PANEL;

  const getEventAvailability = (menuEvent: CalendarEvent): string => {
    const dayOfWeek = menuEvent?.schedule?.dayOfWeek;
    if (!dayOfWeek)
      return translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.availableEveryDay`);
    const weekdays = [1, 2, 3, 4, 5];
    if (weekdays.every((day) => dayOfWeek.includes(day))) {
      return translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.availableEveryWeekday`);
    }
    const luxonDays = dayOfWeek.map((day) => (day === 0 ? 6 : day - 1)).toSorted((a, b) => a - b);

    const text = luxonDays
      .reduce((acc, val) => {
        acc += Info.weekdaysFormat('short')[val];
        acc += ', ';
        return acc;
      }, '')
      .slice(0, -2);
    return translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.customAvailability`, {
      text,
    });
  };

  const getEventRotation = (menuEvent: CalendarEvent): string => {
    const repeat = menuEvent.schedule.every;
    if (!repeat || repeat.week === 1) {
      return translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.repeatEveryWeek`);
    }
    const repeatEvery = Object.keys(repeat)[0];
    // @ts-expect-error FIXME: Element implicitly has an 'any' type because expression of type 'string' can'...
    const repeatEveryN = repeat[repeatEvery];
    const text = `${repeatEveryN} ${repeatEvery}s`;
    return translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.customRepeat`, { text });
  };

  const isMenuEventVisible = (menuEvent: CalendarEvent): boolean => {
    return !menuEvent?.data?.is?.disabled;
  };

  const getOrderMethods = (pickup: boolean, delivery: boolean): string => {
    let orderMethods = `${translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.title`)} `;
    if (pickup && delivery) {
      orderMethods += `${translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.pickup`)}, ${translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.dropoff`)}`;
    } else if (pickup) {
      orderMethods += translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.pickup`);
    } else if (delivery) {
      orderMethods += translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.dropoff`);
    } else {
      orderMethods += translate(`${LOCALE_PREFIX}.menuSchedulePanel.eventCard.orderMethod.none`);
    }
    return orderMethods;
  };

  return {
    getEventAvailability,
    getEventRotation,
    isMenuEventVisible,
    getOrderMethods,
  };
};
